export default __webpack_public_path__ + "static/media/sales.c62858f1.png";